import { OutlinedField, OutlinedFieldProps } from '@/components/common/field/OutlinedField';
import { PhoneNumberInput } from '@/components/common/field/PhoneNumberInput';
import React, { FC } from 'react';

type Props = OutlinedFieldProps;

/**
 * The phone field used everywhere except the profile phone dialog —
 * the letter and answer author forms, and the card issuing form.
 * It formats as the user types and takes a number in any notation, a foreign one included.
 * The masked Russia-only variant is `RussianPhoneNumberField`, and it belongs to the profile alone.
 */
export const PhoneNumberField: FC<Props> = (props: Props) => {
  return <OutlinedField {...props} inputComponent={PhoneNumberInput} />;
};
